"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=(S=>(S.NORMAL="NORMAL",S.PLUS="PLUS",S.MINUS="MINUS",S.STOP="STOP",S))(e||{});exports.ChemistryRating=e;
